module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var numFormat = function (num) {
    num = num? num + '' : '';
    return num.replace('.',',');
}

    ; __append("\n<div class=\"wh100\">\n    <table class=\"w100 gl-report__table width-regulator\">\n        <thead>\n        <tr>\n            <td>Культура</td>\n            <td class=\"ta-center\">Минимальная урожайность  (ц/га)</td>\n            <td class=\"ta-center\">Максимальная урожайность  (ц/га)</td>\n            <td class=\"ta-center\">Средняя урожайность  (ц/га)</td>\n        </tr>\n        </thead>\n    </table>\n\n    <div class=\"wh100\">\n        <div class=\"cell__abs_container\">\n            <div class=\"cell__abs overflow-y__auto\">\n                <table class=\"w100 gl-striped__table gl-report__table width-regulator\">\n                    <tbody>\n\n                    ")
    ;  data.rows.forEach(function (row) { 
    ; __append("\n\n                    <tr>\n                        <td>")
    ; __append(escapeFn( row.culture ))
    ; __append("</td>\n                        <td class=\"ta-center\">")
    ; __append(escapeFn( numFormat(row.harvest_min) ))
    ; __append("</td>\n                        <td class=\"ta-center\">")
    ; __append(escapeFn( numFormat(row.harvest_max) ))
    ; __append("</td>\n                        <td class=\"ta-center\">")
    ; __append(escapeFn( numFormat(row.harvest_avg) ))
    ; __append("</td>\n                    </tr>\n\n                    ")
    ;  }) 
    ; __append("\n\n                    <tr>\n                        <th>")
    ; __append(escapeFn( data.total.text ))
    ; __append("</th>\n                        <th class=\"ta-center\">")
    ; __append(escapeFn( numFormat(data.total.harvest_min) ))
    ; __append("</th>\n                        <th class=\"ta-center\">")
    ; __append(escapeFn( numFormat(data.total.harvest_max) ))
    ; __append("</th>\n                        <th class=\"ta-center\">")
    ; __append(escapeFn( numFormat(data.total.harvest_avg) ))
    ; __append("</th>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}